var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrow3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 104,
  height: 104,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M46.378 5.54c42.934 49.306-7.631 84.813-24.411 65.951C0 46.801 62.69 23.874 96.9 62.328m0 0l-13.938-1.833M96.9 62.328l.571-11.896",
  stroke: "#006C47",
  strokeWidth: 3,
  strokeLinecap: "round"
})));
export default SvgArrow3;